export const peripheryAddresses = {
  adaptiveCurveIRMFactory: "0x6155921DaEa6a8Dca108c4B434bC66E1c51F6d6E",
  capRiskStewardFactory: "0x34718b85452021Df5403A38CE798d80921921079",
  edgeFactory: "0x34A260811256abc5EB13BE6C867197d0C0133F9D",
  edgeFactoryPerspective: "0x546d1E3C430C712A610Df311727529aa6512c7e5",
  escrowedCollateralPerspective: "0x65B8Faec13bA76Decc5dc5678bf356954cCd6823",
  eulerEarnFactoryPerspective: "0x4E5e9BCafeA5C68E8D93CAb3cF1833fC0c77b0eF",
  eulerEarnGovernedPerspective: "0xEF7599ef1CB0ec48ED6f4174641462D6919A7CE2",
  eulerEarnPublicAllocator: "0xD561479477b03720bF485e91B76574374A646531",
  eulerUngoverned0xPerspective: "0xea19a15182A78e8fFF080F79C769FBB590f4D3E9",
  eulerUngovernedNzxPerspective: "0x32581e478819f24434baC9041542770026cE32A7",
  evkFactoryPerspective: "0x9d928D359646dC4249A8d57259d87673F118Ec85",
  externalVaultRegistry: "0x74171139d712AE64faA8cEFA524e13fd52826c1b",
  feeCollector: "0x0000000000000000000000000000000000000000",
  feeFlowController: "0xE7Ef8C7CcB6aa81e366f0A0ccd89A298d9893E83",
  feeFlowControllerUtil: "0x20d7B41c7b00DeDBF8Eff88A3C3832B5cF299555",
  fixedCyclicalBinaryIRMFactory: "0x5151a8125B91A220fFe8fEA2Ab2815b46ecaAfFb",
  governedPerspective: "0x775231E5da4F548555eeE633ebf7355a83A0FC03",
  governorAccessControlEmergencyFactory:
    "0x71620376630597FA901112821455814a31d39685",
  irmRegistry: "0x69e47D24dE839423A94afcD01b88C1683BA4D1D0",
  kinkIRMFactory: "0x40739156B75b477f5b4f2D671655492B535B59d2",
  kinkyIRMFactory: "0x996E67A00D2dd4e2Ace3c507250524aC66438254",
  oracleAdapterRegistry: "0xd6238D3b8bEEd1C7f424eBF6fc1CcD7fe1b31665",
  oracleRouterFactory: "0xbe83f65e5e898D482FfAEA251B62647c411576F1",
  swapVerifier: "0xA8a4f96EC451f39Eb95913459901f39F5E1C068B",
  swapper: "0xAE4043937906975E95F885d8113D331133266Ee4",
  termsOfUseSigner: "0xA64404Dfd8Ea52ff8dA151442864C3c7C701e4A1",
} as const
